const LANGUAGE_KEY = "BYD_language";

export function saveLanguage(lng: string) {
  localStorage.setItem(LANGUAGE_KEY, lng);
}

export function getLanguage(): string | null {
  return localStorage.getItem(LANGUAGE_KEY);
}
